import { combineReducers } from 'redux';

import RolesReducer from './RolesReducer';
import aiReducer from './aiReducer';
import aiReportsReducer from './aiReportsReducer';
import areaSelectionReducer from './areaSelectionReducer';
import authReducer from './authReducer';
import companyReducer from './companyReducer';
import dashboardLinkingReducer from './dashboardLinkingReducer';
import flashMessageReducer from './flashMessage';
import forecastStoreReducer from './forecastStoreReducer';
import forecastingDataReducer from './forecastingDataReducer';
import layerManagementReducer from './layerManagementReducer';
import locationOfInterestReducer from './locationOfInterestReducer';
import reamsReducer from './reamsReducer';
import retailReducer from './retailReducer';
import timeSliderReducer from './timeSliderReducer';
import uiReducer from './uiReducer';
import userReducer from './userReducer';

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  roles: RolesReducer,
  company: companyReducer,
  ui: uiReducer,
  forecastingData: forecastingDataReducer,
  timeSlider: timeSliderReducer,
  forecastStore: forecastStoreReducer,
  flashMessages: flashMessageReducer,
  dashboardLinking: dashboardLinkingReducer,
  locationOfInterest: locationOfInterestReducer,
  areaSelection: areaSelectionReducer,
  layerManagement: layerManagementReducer,
  retail: retailReducer,
  reams: reamsReducer,
  aiReports: aiReportsReducer,
  ai: aiReducer,
});
